import React from 'react';
import { useT } from '~app/core/BundleProvider';

const buildTime = new Date(process.env.REACT_APP_BUILD_TIME);
const options = { year: 'numeric', month: 'long', day: 'numeric' };

const SupportingInfo = () => {
  const t = useT();
  return (
    <div role="main" className="InfoPage__container supportingInfo">
      <h1>{t('sup-info')}</h1>
      <details open>
        <summary>{t('summary')}</summary>
        <p>
          {t('tool-introduces')}{' '}
          <a
            href="https://www.biointeractive.org/classroom-resources/model-builder"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('this-page')}
          </a>
          .
        </p>
      </details>
      <details open>
        <summary>{t('instructions-for-use')}</summary>
        {t('features-on-landing1')} <em>{t('site-name')}</em>{' '}
        {t('features-on-landing2')}
        <ul>
          <li>
            <strong>{t('open-a-model')}:</strong> {t('open-previously-saved')}
          </li>
          <li>
            <strong>{t('creation-tool')}:</strong> {t('create-from-scratch')}
          </li>
          <li>
            <strong>{t('grading-tool')}:</strong> {t('automatically-grade')}
          </li>
          <li>
            <strong>{t('choose-model')}:</strong> {t('open-biointeractive')}
          </li>
        </ul>
        {t('for-more-information')}{' '}
        <a
          href="https://www.biointeractive.org/classroom-resources/model-builder"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('this-page')}
        </a>
        .
      </details>
      <details>
        <summary>{t('optimization-and-limitations')}</summary>
        <p>{t('browser-and-device-support')}</p>
        <p>
          {t('most-components-designed-for')}{' '}
          <a
            href="https://www.biointeractive.org/commitment-accessibility"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('accessibility')}
          </a>{' '}
          {t('compliance')} (
          <a
            href="https://www.w3.org/WAI/standards-guidelines/wcag/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('wcag')}
          </a>{' '}
          {t('level-2-criteria')}). {t('users-of-jaws')}
        </p>
        <p>
          {t('for-feedback')}:{' '}
          <a
            href="mailto:biointeractive@hhmi.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            biointeractive@hhmi.org
          </a>
          .
        </p>
      </details>
      <details>
        <summary>{t('credits')}</summary>
        <div className="InfoPage__container__credits">
          <p>
            <strong>{t('producers')}</strong>
            <br />
            Jon Darkow, Seneca East High School, OH
            <br />
            David Julian, University of Florida, FL
            <br />
            Mark Nielsen, HHMI
          </p>
          <p>
            <strong>{t('reviewer')}</strong>
            <br /> Diana Fisher,{' '}
            <a
              href="https://ccmodelingsystems.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              CC Modeling Systems
            </a>
          </p>
          <p>
            <strong>{t('editing')}</strong>
            <br />
            Esther Shyu, HHMI
          </p>
          <p>
            <strong>{t('uiux-dev')}</strong>
            <br />
            <a
              href="https://www.digitalartefacts.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Digital Artefacts, Inc
            </a>
            .
          </p>
          <p></p>
          <p>
            &copy; {new Date().getFullYear()} Howard Hughes Medical Institute.
            The resource is licensed under a{' '}
            <a
              href="https://creativecommons.org/licenses/by-nc-sa/4.0/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Creative Commons Attribution-NonCommercial-ShareAlike 4.0
              International license
            </a>
            .
          </p>
        </div>
      </details>

      <div className="InfoPage__container__credits">
        <p>
          {t('version')} {process.env.REACT_APP_VERSION} <br />
          {t('updated')} {buildTime.toLocaleDateString(undefined, options)}
        </p>
      </div>
    </div>
  );
};

export default SupportingInfo;
